import {Component, OnInit} from '@angular/core';
import {IMyDateModel} from 'mydatepicker';

@Component({
    selector: 'statistic-evolution',
    templateUrl: './templates/statistic-evolution.component.html',
    styleUrls: ['./styles/bootstrap.css', './styles/statistic-evolution.component.css']
})
export class StatisticEvolutionComponent implements OnInit {

    date_from: any;
    date_to: any;

    toggle_chart: any = 1;

    constructor() {}

    ngOnInit() {
    }

    onDate1Changed(event: IMyDateModel) {
        if (event.jsdate === null) {
            this.date_from = "";
        } else {
            this.date_from = event.jsdate.toLocaleDateString("en-US");
        }
    }
    onDate2Changed(event: IMyDateModel) {
        if (event.jsdate === null) {
            this.date_to = "";
        } else {
            this.date_to = event.jsdate.toLocaleDateString("en-US");
        }
    }

    public barChartOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true
    };
    public barChartLabels: string[] = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
    public barChartType: string = 'bar';
    public barChartLegend: boolean = true;

    public barChartData: any[] = [
        {data: [-55, 59, -12, 81, 56, 55, 40], label: 'Series A'}
    ];

    public lineChartOptions: any = {
        responsive: true
    };
    public lineChartColors: Array<any> = [
        { // grey
            backgroundColor: 'rgba(148,159,177,0.2)',
            borderColor: 'rgba(148,159,177,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        },
        { // dark grey
            backgroundColor: 'rgba(77,83,96,0.2)',
            borderColor: 'rgba(77,83,96,1)',
            pointBackgroundColor: 'rgba(77,83,96,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(77,83,96,1)'
        },
        { // grey
            backgroundColor: 'rgba(148,159,177,0.2)',
            borderColor: 'rgba(148,159,177,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        }
    ];
    public lineChartType: string = 'line';

    // events
    public chartClicked(e: any): void {
        console.log(e);
    }

    public chartHovered(e: any): void {
        console.log(e);
    }


    checked = false;
    indeterminate = false;
    align = 'start';
    disabled = false;

}



// WEBPACK FOOTER //
// ./src/app/statistic-evolution.component.ts